import * as clientConfig0 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-active-header-links/lib/client/config.js'
import * as clientConfig1 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-back-to-top/lib/client/config.js'
import * as clientConfig2 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-copy-code/lib/client/config.js'
import * as clientConfig3 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-markdown-hint/lib/client/config.js'
import * as clientConfig4 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-medium-zoom/lib/client/config.js'
import * as clientConfig5 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-nprogress/lib/client/config.js'
import * as clientConfig6 from '/home/runner/work/docs/docs/src/.vuepress/.temp/prismjs/config.js'
import * as clientConfig7 from '/home/runner/work/docs/docs/src/.vuepress/.temp/markdown-tab/config.js'
import * as clientConfig8 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-theme-data/lib/client/config.js'
import * as clientConfig9 from '/home/runner/work/docs/docs/node_modules/@vuepress/theme-default/lib/client/config.js'
import * as clientConfig10 from '/home/runner/work/docs/docs/node_modules/@vuepress/plugin-search/lib/client/config.js'
import * as clientConfig11 from '/home/runner/work/docs/docs/src/.vuepress/.temp/register-components/clientConfig.5dbd0ec0.js'

export const clientConfigs = [
  clientConfig0,
  clientConfig1,
  clientConfig2,
  clientConfig3,
  clientConfig4,
  clientConfig5,
  clientConfig6,
  clientConfig7,
  clientConfig8,
  clientConfig9,
  clientConfig10,
  clientConfig11,
].map((m) => m.default).filter(Boolean)
